import { IsNotEmpty, IsString } from 'class-validator';

export class FollowUserDto {
	@IsString()
	@IsNotEmpty()
	followedId: string;

	@IsString()
	@IsNotEmpty()
	lobbyId: string;
}

export class GetFollowingsDto {
	@IsString()
	@IsNotEmpty()
	lobbyId: string;
}

export class SearchUsersDto {
	@IsString()
	@IsNotEmpty()
	lobbyId: string;

	@IsString()
	@IsNotEmpty()
	search: string;
}

export class FollowingDto {
	id: string;
	user_id: string;
	full_name: string;
	label?: string | null;
	img_variants: any;
	country?: string | null;
	rank?: number | null;
}
